import { Theme, useMediaQuery } from '@mui/material'

const useIsMobile = () => useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'), { noSsr: true })

export default useIsMobile
